import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export const removeNonVisualizedProduct = (set, get, sku) => {
  const state = get();
  if (!state || !state.designs || !state.designs[state.selectedDesignId]) return;

  const cart = Array.isArray(state.designs[state.selectedDesignId].Cart)
    ? [...state.designs[state.selectedDesignId].Cart]
    : [];

  const idx = cart.findIndex((item) => String(item.Sku) === String(sku));
  if (idx === -1) return; // Item not found, nothing to remove

  if (cart[idx].Quantity > 1) {
    cart[idx] = { ...cart[idx], Quantity: cart[idx].Quantity - 1 };
  } else {
    cart.splice(idx, 1); // Remove item if quantity is 1
  }

  set({
    designs: {
      ...state.designs,
      [state.selectedDesignId]: {
        ...state.designs[state.selectedDesignId],
        Cart: cart,
      },
    },
  }, false, { type: 'REMOVE_NON_VISUALIZED_PRODUCT', payload: { designId: state.selectedDesignId, sku } });

  const newRelicPayload = {
    nonVisualizedProductRemoved: { designId: state.selectedDesignId, sku }
  };

  logNewRelicCustom(NEW_RELIC_EVENTS.NON_VISUALIZED_PRODUCT_REMOVED, newRelicPayload);
};
